export const FileCard = ({ fileName }: { fileName: string }) => {
  return (
    <div className="bg-neutral-7 p-3 flex flex-col gap-6 h-fit rounded-md w-fit max-w-[240px]">
      <div className="h-6 w-6 bg-neutral-6 flex items-center justify-center">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.3335 4.66663H10.6668"
            stroke="#505050"
            strokeLinejoin="round"
          />
          <path
            d="M5.3335 7.33337H8.00016"
            stroke="#505050"
            strokeLinejoin="round"
          />
          <path
            d="M13.4058 10H9.00016V14.2886M13.6668 10V1.34004C13.6668 1.33636 13.6638 1.33337 13.6602 1.33337H2.34016C2.33648 1.33337 2.3335 1.33636 2.3335 1.34004V14.66C2.3335 14.6637 2.33648 14.6667 2.34016 14.6667H9.00016L13.6668 10Z"
            stroke="#505050"
          />
        </svg>
      </div>
      <p className="body-14-medium truncate">{fileName}</p>
    </div>
  );
};
